import React, { useState, useEffect } from 'react';
import AccueilButtons from './Components/Accueil-buttons';
import './Suggestion.css';
import { updateUserData, getUserData, getPlayFabId } from './api';

function Suggestion() {
    const [suggestion, setSuggestion] = useState('');
    const [historiqueSuggestions, setHistoriqueSuggestions] = useState([]);
    const [playFabId, setPlayFabId] = useState(null);  // Variable d'état pour stocker l'ID PlayFab

    // Charger l'ID PlayFab dès que le composant est monté
    useEffect(() => {
        const recupererPlayFabId = async () => {
            try {
                const id = await getPlayFabId(); // Appeler la fonction pour obtenir l'ID PlayFab
                setPlayFabId(id); // Mettre à jour l'état avec l'ID PlayFab récupéré
            } catch (error) {
                console.error('Erreur lors de la récupération de l\'ID PlayFab:', error);
            }
        };

        recupererPlayFabId();
    }, []); // Cette fonction s'exécute une seule fois au montage du composant

    // Charger l'historique des suggestions lorsque playFabId est disponible
    useEffect(() => {
        if (playFabId) {
            const chargerHistorique = async () => {
                try {
                    const historique = await getUserData(playFabId); // Charger l'historique des suggestions
                    setHistoriqueSuggestions(historique); // Mettre à jour l'état avec l'historique
                } catch (error) {
                    console.error('Erreur lors du chargement des suggestions:', error);
                }
            };

            chargerHistorique();
        }
    }, [playFabId]); // Recharger l'historique quand playFabId change

    // Soumettre une nouvelle suggestion
    const handleSubmit = () => {
        if (suggestion.trim() !== '') {
            const nouvellesSuggestions = [suggestion, ...historiqueSuggestions.slice(0, 9)];
            setHistoriqueSuggestions(nouvellesSuggestions); // Mettre à jour l'historique local
            envoyerSuggestionWeb(suggestion); // Envoi de la suggestion à un autre serveur
            updateHistoriqueSuggestions(nouvellesSuggestions); // Mettre à jour l'historique des suggestions sur le serveur
            setSuggestion(''); // Réinitialiser le champ de saisie
        }
    };

    // Fonction pour envoyer la suggestion à un autre serveur web
    const envoyerSuggestionWeb = (suggestion) => {
        const url = "https://votrepage.com/collecte-suggestions";
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ suggestion })
        }).catch(error => console.error("Erreur de connexion:", error));
    };

    // Mettre à jour l'historique des suggestions sur le serveur
    const updateHistoriqueSuggestions = async (nouvellesSuggestions) => {
        try {
            await updateUserData(playFabId, nouvellesSuggestions); // Mise à jour des données utilisateur
        } catch (error) {
            console.error('Erreur lors de la mise à jour de l\'historique des suggestions:', error);
        }
    };

    // Si l'ID PlayFab n'est pas encore chargé, afficher un message de chargement
    if (!playFabId) {
        return <div>Chargement...</div>;
    }

    return (
        <div className="Suggestion-container">
            <AccueilButtons />

            {/* Vos rectangles existants */}
            <div className="Rectangle56"></div>
            <div className="Rectangle102"></div>
            <div className="Rectangle103"></div>
            <div className="Rectangle114"></div>
            <div className="Rectangle109"></div>
            <div className="Rectangle110"></div>
            <div className="Rectangle108"></div>
            <div className="Rectangle107"></div>
            <div className="Rectangle104"></div>
            <div className="Rectangle101"></div>
            <div className="Rectangle78"></div>
            <div className="Rectangle111"></div>
            <div className="Rectangle106"></div>
            <div className="IdeaLogo"></div>
            <div className="Int">.Int</div>

            <h1>Suggestions</h1>

            {/* Champ de saisie de suggestion */}
            <input 
                type="text" 
                value={suggestion} 
                onChange={(e) => setSuggestion(e.target.value)} 
                placeholder="Entrez votre suggestion de thématique" 
                className="suggestion-input"
            />

            {/* Bouton pour soumettre la suggestion */}
            <button onClick={handleSubmit} className="suggestion-button">Envoyer</button>

            {/* Historique des suggestions */}
            <div className="suggestion-historique">
                <h2>-Historique des suggestions-</h2>
                <ul>
                    {historiqueSuggestions.map((sugg, index) => (
                        <li key={index}>{sugg}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default Suggestion;
